import * as Yup from 'yup';
import { parseDecimalAmountInput } from '../utils/numberUtils';

const amountField = Yup.string()
  .required('Miktar zorunludur')
  .test('valid-amount', 'Geçerli bir miktar giriniz (örn. 120,05)', value => {
    const parsed = parseDecimalAmountInput(value ?? '');
    return parsed !== null && parsed > 0;
  })
  .test('min-amount', 'Miktar en az 0,01 olmalıdır', value => {
    const parsed = parseDecimalAmountInput(value ?? '');
    return parsed !== null && parsed >= 0.01;
  });

export const ExpenseFormSchema = Yup.object({
  amount: amountField,
  expenseDate: Yup.date().required('Tarih zorunludur'),
  description: Yup.string()
    .trim()
    .required('Açıklama zorunludur')
    .min(3, 'Açıklama en az 3 karakter olmalıdır'),
  files: Yup.array().nullable(),
});

export const EditExpenseFormSchema = ExpenseFormSchema.shape({
  status: Yup.string().oneOf(['Pending', 'Approved', 'Rejected']).optional(),
});
